<template>
    <swiper-slide
            class="holopage swiper-no-swiping"
            id="toholopage"
            v-if="showswiper"
          >
            <div style="width: 100%; height: 33px"></div>
            <div class="hptop">
              <div class="hptop-left" @click="goback">
                <img src="../assets/iPad icon/返回@2x.png" alt="" />
                <p>返回</p>
              </div>
              <div class="hptop-right">
                <img src="../assets/iPad icon/提示@2x.png" alt="" />
                <p>提示</p>
              </div>
            </div>
            <div id="hpbottom" v-show="showswiper"   
                >
              <video
                ref="video"
                :src="info.goods_video.url"
                @touchmove="touchMove"
                @touchstart="touchStart"
                autoplay
                loop
                class="video"
                width="340px"
                height="483px"
                controls
              ></video>
            </div>
          </swiper-slide>
</template>

<script>
export default {
    props:{
        showswiper:{
            type:Boolean,
            value:false
        },
        info:{
            type:Object,
            value:{}
        }
    },
    data () {
        return {
            time:3,
            startX:0,
            startY:0,
            throttleFlag:true
        }
    },
    methods:{
        // 节流
    throttle(func,delay,e) {
        if(this.throttleFlag){
          this.throttleFlag=false
          return func.call(this,e,delay)
        }else{
          return
        }
    },
    touchMoveFn(e,delay) {
        var endX = Number(e.touches[0].clientX);
        var endY = Number(e.touches[0].clientY);
        console.log(this.startX );
        var diffX = endX - this.startX;
        console.log(this.startX);
        var diffY = endY - this.startY;
        try {
            if (diffX > 0) { //向右移动
                this.$refs.video.currentTime !== 0 ? this.$refs.video.currentTime += this.time : 1;
            } else if (diffX < 0) { //向左移动
                this.$refs.video.currentTime !== 0 ? this.$refs.video.currentTime -= this.time : 1;
            }
            setTimeout(()=>{
              this.throttleFlag = true
            },delay)
        } catch (e) {
            console.log(e.message);
        }
    },
    touchMove(e){
      this.throttle(this.touchMoveFn,1000,e)
    },
    touchStart (e) {
        try {
            this.startX = Number(e.touches[0].clientX);
            this.startY = Number(e.touches[0].clientY);
        } catch (e) {
            console.log(e.message);
        }
    },
    goback(){
        this.$emit("gobackFn")
    }
    }
}
</script>
 
<style lang = "less" scoped>
    
</style>